import { Colors } from "@auteco/theme";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    card: {
        padding: '20px',
        marginBottom: '12px'
    },
    title: {
        marginBottom: '20px',
        fontSize: '20px',
        color: Colors.DARK_BLUE
    },
    textField: {
        width: '300px',
    }
}))

export default useStyles